import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000,
});

export const fetchOverview = () => API.get('/dashboard/overview');
export const fetchMapData = () => API.get('/dashboard/map-data');
export const fetchAlerts = () => API.get('/alerts');
export const fetchBatons = (params) => API.get('/batons', { params });
export const fetchPatrols = (params) => API.get('/patrols', { params });
export const resolveAlert = (id, data) => API.put(`/alerts/${id}/resolve`, data);
export const broadcastMessage = (data) => API.post('/alerts', data);
// Add this line to api.js
export const deleteAlert = (id) => API.delete(`/alerts/${id}`);

export default API;